<div>
    @for (module of contentModules(); track module.id) {
        @if (module.type === DealerCampaignContentModuleType.TEASER) {
            <ui-m030-c150-teaser-list [data]="module.teasers" [headline]="module.headline || ''" />
        } @else if (module.type === DealerCampaignContentModuleType.FINANCE_OFFER) {
            <ui-m060-c020-vehicle-leasing-example
                [isFirstView]="true"
                [image]="{ url: module.financeOffer.image }"
                [link]="'mailto:' + module.financeOffer.email + '?subject=' + module.financeOffer.emailSubject"
                [imageCaption]="module.financeOffer.imageDescription"
                [headline]="module.financeOffer.headline"
                [tableHeadlineValue]="module.financeOffer.financeRate"
                [tableData]="[
                    {
                        label: 'Fahrzeugpreis',
                        value: (module.financeOffer.vehiclePrice | formatPrice) + ' ' + 'EUR',
                    },

                    {
                        label: 'Anzahlung',
                        value: (module.financeOffer.depositPayment | formatPrice) + ' ' + 'EUR',
                    },
                    {
                        label: 'Nettodarlehensbetrag',
                        value: (module.financeOffer.netLoanAmount | formatPrice) + ' ' + 'EUR',
                    },
                    {
                        label: 'Laufzeit',
                        value: module.financeOffer.duration + ' ' + 'Monate',
                    },
                    {
                        label: 'Gesamtlaufleistung',
                        value: module.financeOffer.totalMileage,
                    },
                    {
                        label: 'Monatliche Rate',
                        value: module.financeOffer.financeRate,
                    },
                    {
                        label: 'Schlussrate',
                        value: module.financeOffer.finalRate,
                    },
                    {
                        label: 'Gesamtbetrag',
                        value: (module.financeOffer.financeTotalPrice | formatPrice) + ' ' + 'EUR',
                    },
                    {
                        label: 'Effektiver Jahreszins',
                        value: module.financeOffer.effectiveAnnualRate + ' ' + ' %',
                    },
                    {
                        label: 'Gebundener Sollzinssatz p.a.',
                        value: module.financeOffer.fixedAnnualRate + ' ' + ' %',
                    },
                ]"
                [envkvText]="
                    module.financeOffer.specificModel +
                    ' ' +
                    module.financeOffer.power +
                    ': ' +
                    module.financeOffer.envkv
                "
                [text]="module.financeOffer.text"
                [priceBadge]="{ price: module.financeOffer.financeRate, text: 'Finanzierung mtl. für:' }"
                linkText="Angebot erhalten"
                tableHeadline="Monatliche Rate"
            />
        } @else if (module.type === DealerCampaignContentModuleType.CASH_PRICE_OFFER) {
            <ui-m060-c020-vehicle-leasing-example
                [isFirstView]="true"
                [image]="{ url: module.cashPriceOffer.image }"
                [link]="'mailto:' + module.cashPriceOffer.email + '?subject=' + module.cashPriceOffer.emailSubject"
                [imageCaption]="module.cashPriceOffer.imageDescription"
                [headline]="module.cashPriceOffer.headline"
                [tableHeadlineValue]="module.cashPriceOffer.cashPrice"
                [tableData]="[]"
                [envkvText]="
                    module.cashPriceOffer.specificModel +
                    ' ' +
                    module.cashPriceOffer.power +
                    ': ' +
                    module.cashPriceOffer.envkv
                "
                [text]="module.cashPriceOffer.text ?? ''"
                [priceBadge]="{ price: module.cashPriceOffer.cashPrice, text: 'Barpreis:' }"
                linkText="Angebot erhalten"
                tableHeadline="Barpreis"
            />
        } @else if (module.type === DealerCampaignContentModuleType.LEASING_OFFER) {
            @let imageCaption = module.leasingOffer.imageDescription || '' | footnotes;

            <ui-m060-c020-vehicle-leasing-example
                [isFirstView]="true"
                [image]="{ url: module.leasingOffer.image }"
                [link]="'mailto:' + module.leasingOffer.email + '?subject=' + module.leasingOffer.emailSubject"
                [imageCaption]="imageCaption()"
                [headline]="module.leasingOffer.headline"
                [tableHeadlineValue]="module.leasingOffer.leasingRate"
                [tableData]="[
                    {
                        label: 'Einmalige Leasingsonderzahlung',
                        value: (module.leasingOffer.leasingSpecialPayment | formatPrice) + ' ' + 'EUR',
                    },
                    {
                        label: 'Laufzeit',
                        value: module.leasingOffer.duration + ' ' + 'Monat/e',
                    },
                    {
                        label: 'Gesamtfahrleistung',
                        value: module.leasingOffer.totalMileage,
                    },
                ]"
                [envkvText]="
                    module.leasingOffer.specificModel +
                    ' ' +
                    module.leasingOffer.power +
                    ': ' +
                    module.leasingOffer.envkv
                "
                [text]="module.leasingOffer.text"
                linkText="Angebot erhalten"
                tableHeadline="Monatliche Rate"
            />
        } @else if (module.type === DealerCampaignContentModuleType.IMAGE_TEXT) {
            @let imageCaption = module.imageText.imageDescription || '' | footnotes;

            <ui-m030-c020-teaser-allrounder
                class="inner-page-wrapper-px-0 block"
                [isFirstView]="true"
                [image]="module.imageText.image"
                [badge]="module.imageText.imageBadge || ''"
                [greyBackground]="false"
                [isReverse]="module.imageText.imageRight"
                [imageCaption]="imageCaption()"
            >
                @let headline = module.imageText.headline | footnotes;
                <h1 [innerHTML]="headline()" headline></h1>
                @let subHeadline = module.imageText.subHeadline || '' | footnotes;
                <h2 class="mb-24" [innerHTML]="subHeadline()" subheadline></h2>
                @let copy = module.imageText.copy || '' | footnotes;
                <p [innerHTML]="copy()" text></p>

                <ng-container cta>
                    @if (module.imageText.linkText) {
                        @let linkText = module.imageText.linkText | footnotes;
                        @if (module.imageText.email) {
                            <a
                                class="button-primary w-max px-48"
                                [href]="
                                    'mailto:' + module.imageText.email + '?subject=' + module.imageText.emailSubject
                                "
                                [innerHTML]="linkText()"
                            ></a>
                        } @else {
                            <a
                                class="button-primary w-max px-48"
                                [hyundaiRouterLink]="module.imageText.link"
                                [innerHTML]="linkText()"
                            ></a>
                        }
                    }
                </ng-container>
            </ui-m030-c020-teaser-allrounder>
        }
    }
</div>
